import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    leaveTypes: [],
    tableLoading: false,
    viewContainerLoading: false,
    showViewContainer: false,
    searchQuery: "",
    currentPage: 1,
    perPage: 5,
    leaveTypeTotal: null,
    totalLeaveApprover: null,
    leaveTotal: null,
    branches: [],
    departments: [],
    currentLeaveType: {},
    leaveApprovers: [],
    currentLeaveApprover: {},
    employees: [],
    employeeGrades: [],
    leavesData: [],
    currentLeave: {},
    filterValue: "",
    filterDate: "",
    filterLeaveTypes: "",
    employeeLeave: [],
    employeeLeaveEmployeeId: null,
    leaveTypesSearch: [],
  },
  actions,
  getters,
  mutations,
};
